export default __webpack_public_path__ + "static/media/united-kingdom.8d725839.svg";